import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import { Helmet } from "react-helmet";
import sanityClient from "../../sanityClient";
import ProjectCards from "../../components/ProjectCards";
import GoogleMapEmbed from "../../components/GoogleMapEmbed"; // Import the new component
import styled from "styled-components";

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const ProjectsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 20px;
  color: var(--primary-color);
`;

const Paragraph = styled.p`
  text-align: center;
  font-size: 1.1em;
`;

const CompletedProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "build" && completionDate != null] | order(completionDate desc) {
          _id,
          name,
          description,
          "imageUrl": mainImage.asset->url,
          address,
          bedrooms,
          bathrooms,
          squareFootage,
          propertyType
        }`
      )
      .then((data) => setProjects(data))
      .catch(console.error);
  }, []);

  return (
    <>
      <Helmet>
        <title>Completed Projects - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Explore the completed projects by Habitat for Humanity Buffalo. See the homes and communities we've built together."
        />
      </Helmet>
      <Container>
        <Title>Completed Projects</Title>
        {projects.length > 0 ? (
          <ProjectsContainer>
            {projects.map((project) => (
              <LazyLoad key={project._id} height={200} offset={100}>
                <ProjectCards project={project} />
              </LazyLoad>
            ))}
          </ProjectsContainer>
        ) : (
          <Paragraph>No completed projects available.</Paragraph>
        )}

        {/* Add the Google Map Embed Section */}
        <Title>Our Impact Across Buffalo and Western New York</Title>
        <Paragraph>
          Since 1985, Habitat for Humanity Buffalo has built nearly 400 homes in
          the Buffalo and Western New York area. Explore our completed houses on
          the map below.
        </Paragraph>
        <GoogleMapEmbed
          src="https://www.google.com/maps/d/embed?mid=1pcp3KQkzXmEhFtbHm16Fz4GASCtnmfeV&ehbc=2E312F"
          title="Habitat for Humanity Buffalo Completed Projects Map"
        />
      </Container>
    </>
  );
};

export default CompletedProjects;
